<template>
  <div>
    <van-sticky>
      <van-nav-bar :border="false">
        <template #left>
          <span class="iconfont icon-houtui fs-24 fw-700" @click="$router.back()"></span>
        </template>
      </van-nav-bar>
    </van-sticky>
    <div v-if="advisory.dirname === 'video'" class="video-wrapper">
      <video class="video" :src="advisory.video_url" :poster="advisory.poster" controls controlslist="nodownload noremote footbar"></video>
    </div>
    <header class="pl-15 pr-15 pb-10 bg-fff">
      <h3 class="fs-24">{{ advisory.title }}</h3>
      <div class="flex align-center mt-10 mb-15">
        <div>
          <van-tag color="#f3f4f6" text-color="#B7BDCA" size="medium" round>原创</van-tag>
          <span class="ml-10 mr-10"><span class="color-0079FF">{{ advisory.author }}</span></span>
        </div>
        <time>{{ advisory.inputtime * 1000 | formatTime }}</time>
      </div>
    </header>
    <main class="main pl-15 pr-15" v-html="advisory.content"></main>
  </div>
</template>

<script>
import { getNoticeInfo } from '@/api/music.js'
export default {
  name: 'AdvisoryDetail',
  data() {
    return {
      advisory: {}
    }
  },
  async created() {
    this.$store.commit('TOGGLE_LOADING', true)
    await this.getNoticeInfo()
    this.$store.commit('TOGGLE_LOADING', false)
  },
  methods: {
    async getNoticeInfo() {
      const { id, catid } = this.$route.query
      const res = await getNoticeInfo({ id, catid })
      this.advisory = res.data
    }
  }
}
</script>

<style lang="scss" scoped>
.video-wrapper{
  width: 100%;
  video{
    object-fit: contain;
    width: inherit;
    height: calc(100vh - 46Px);
  }
}
</style>
<style lang="scss">
.main{
  font-size: 16px;
  line-height: 30px;
  padding-bottom: 150px;
  word-break: break-all;
  p{
    text-indent: 2em;
    text-align: justify;
    margin-bottom: 10px;
  }
  h1,h2, h3,h4,h5{
    font-size: 18px;
    text-align: center;
    margin: 15px;
  }
  img{
    width: 80%;
    margin: 15px 0;
  }

  pre{
    border-left: 5px solid #e5e5e5;
    line-height: 26px;
    padding-left: 15px;
    margin: 15px 0;
  }
}
.bg-fff{
  background-color: #fff;
}
</style>
